<div class="wrapper">
  <ng-container *ngIf="modalContent$ | async as modalContent">
    <span class="title">{{ modalContent.title }}</span>
    <p class="content">{{ modalContent.content }}</p>
  </ng-container>
  <ng-container *ngIf="storeLink$ | async as link">
    <span class="update-btn" *ngIf="link !== 'web'; else refresh" (click)="updateClick(link)">Update Now</span>
    <ng-template #refresh>
      <span class="update-btn" (click)="refreshClick()">Refresh page</span>
    </ng-template>
  </ng-container>
</div>
